<template>
    <div class="hiq-event-view__info" :style="backgroundColor">
        <div class="hiq-event-view__info--block">
            <div class="hiq-event-view__info--tickets" :style="textColor" v-if="event.info.ticket || event.info.ticketInfo">
                <h2 class="hiq-event-view__sub-heading" :class="isVisitSite ? '' : 'hiq-event-view__sub-heading--notVisit'">Biljettinformation</h2>
                <p v-if="event.info.ticketInfo" :style="textColor" class="hiq-event-view__info--tickets__text">{{event.info.ticketInfo}}</p>
                <div v-if="event.info.ticket" class="hiq-event-view__info--tickets__links">
                    <span :style="accentColor" class="hiq-event-view__info--tickets__icon" aria-hidden="true"></span>
                    <a :href="event.info.ticket" :style="accentColor" class="hiq-event-view__info--tickets__link"><span :style="textColor">Extern biljettinformation</span></a>
                </div>
                
            </div>
            <div v-if="event.info.location && event.info.location.name" :style="textColor" class="hiq-event-view__info--location">
                <h2 class="hiq-event-view__sub-heading" :class="isVisitSite ? '' : 'hiq-event-view__sub-heading--notVisit'">Plats</h2>
                <div class="hiq-event-view__info--location__links">
                    <span :style="accentColor" class="hiq-event-view__info--location__icon" aria-hidden="true"></span>
                    <a :href="event.info.location.link" :style="accentColor" class="hiq-event-view__info--location__link"><span :style="textColor">{{event.info.location.name}}</span></a>
                </div>
                
            </div>
            <div v-if="event.info.facebook" :style="textColor" class="hiq-event-view__info--links">
                <h2 class="hiq-event-view__sub-heading" :class="isVisitSite ? '' : 'hiq-event-view__sub-heading--notVisit'">Länkar</h2>
                <div class="hiq-event-view__info--links__facebook">
                    <span :style="accentColor" class="hiq-event-view__info--links__facebook--icon" aria-hidden="true"></span>
                    <a :style="accentColor" class="hiq-event-view__info--links__facebook--link" :href="event.info.facebook"><span :style="textColor">Evenemanget på Facebook</span></a>
                </div>
            </div>
            <div :style="textColor" v-if="event.info.organizer && (event.info.organizer.phone || event.info.organizer.mail || event.info.organizer.link || event.info.organizer.name)" class="hiq-event-view__info--organizer">
                <h2 class="hiq-event-view__sub-heading" :class="isVisitSite ? '' : 'hiq-event-view__sub-heading--notVisit'">Arrangör</h2>
                <div class="hiq-event-view__info--organizer__name" v-if="event.info.organizer.name">
                    {{event.info.organizer.name}}
                </div>
                <div v-if="event.info.organizer.phone" class="hiq-event-view__info--organizer__phone">
                    <span :style="accentColor" class="hiq-event-view__info--organizer__phone--icon" aria-hidden="true"></span>
                    <a :style="accentColor" class="hiq-event-view__info--organizer__links" :href="'tel:' + event.info.organizer.phone"><span :style="textColor"><span class="show-for-sr">Telefon </span>{{event.info.organizer.phone}}</span></a>
                </div>
                <div v-if="event.info.organizer.mail" class="hiq-event-view__info--organizer__mail">
                    <span :style="accentColor" class="hiq-event-view__info--organizer__mail--icon" aria-hidden="true"></span>
                    <a :style="accentColor" class="hiq-event-view__info--organizer__links" :href="'mailto:'+event.info.organizer.mail"><span :style="textColor">E-post till arrangör</span></a>
                </div>
                <div v-if="event.info.organizer.link" class="hiq-event-view__info--organizer__link">
                    <span :style="accentColor" class="hiq-event-view__info--organizer__link--icon" aria-hidden="true"></span>
                    <a :style="accentColor" class="hiq-event-view__info--organizer__links" :href="event.info.organizer.link"><span :style="textColor">Länk till arrangör</span></a>
                </div>
            </div>
        </div>
        <div class="hiq-event-view__info--block" :style="textColor" v-if="event.relatedEvents && event.relatedEvents.length">
            <h2 class="hiq-event-view__sub-heading" :class="isVisitSite ? '' : 'hiq-event-view__sub-heading--notVisit'">Fler tillfällen</h2>
            <other-occasion v-for="event in event.relatedEvents" :key="event.id" :event="event"/>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import OtherOccasion from './OtherOccasions.vue';

export default {
    name: 'Info',
    computed: {
        event() { return this.$store.state.event },
        backgroundColor() { return this.$store.getters.backgroundColor; },
        textColor() { return this.$store.getters.textColor; },
        accentColor() { return this.$store.getters.accentColor; },
        isVisitSite() { return this.$store.state.isVisitSite; }
    },

    components: {
        OtherOccasion
    },
}
</script>